import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { hideDialog, refresher } from "../../../redux/guest-slices/other.slice";
import { handleCancelAppointment } from "../../../redux/member-slices/appointment.slice";
import { handleSpecialistCancelAppointment } from "../../../redux/specialist-slices/appointments.slice";
import { checkUserType } from "../../../utils/helper";
import Icons from "../../../assets/js/Icons";

function AppointmentCancelConfirm() {
  const dispatch = useDispatch();

  const { data } = useSelector(
    (state) => state.otherSlice
  );

  const handleClose = () => {
    dispatch(hideDialog());
  };

  const handleConfirmCancellation = () => {
    const userRole = checkUserType();
    const cancelAction =
      userRole === "specialist"
        ? handleSpecialistCancelAppointment({
            id: data?.appointmentId,
            formData: {},
          })
        : handleCancelAppointment({
            id: data?.appointmentId,
            formData: {},
          });

    dispatch(cancelAction)
      .unwrap()
      .then(() => {
        handleClose();
        dispatch(refresher());
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Reschedule Not Available
        </Typography>

        <IconButton
          sx={{
            top: 10,
            right: 10,
            position: "absolute",
          }}
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          textAlign="center"
          fontSize={16}
        >
          This appointment is within 24 hours of
          the scheduled start time.
        </Typography>

        <Typography
          textAlign="center"
          mt={2}
          fontSize={16}
        >
          Rescheduling is not allowed.
          Would you like to cancel this
          appointment instead?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 3,
        }}
      >
        <Button
          color="error"
          variant="contained"
          onClick={handleClose}
        >
          No
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={handleConfirmCancellation}
        >
          Yes, Cancel Appointment
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default AppointmentCancelConfirm;